import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { Row, Col, Button, Card, Form, Badge } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useLoader } from '../../../../context/LoaderCotext';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import Swal from 'sweetalert2';
import { deleteSHSFile } from '../../../../services/FileService';
import axiosInstance from '../../../../services/AxiosInstance';
import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { addHistory, getTuitionsByEmailYear } from '../../../../services/TuitionService';
import { getMTEByEmail } from '../../../../services/MTEService';
import {
  getSubcontractorByProgram,
  getSubcontractorPrograms,
  getSubcontractorsForMe,
} from '../../../../services/SubcontractorService';

const validationSchema = Yup.object({
  subcontractor: Yup.object().required('Subcontractor is required'),
  subcontractNumber: Yup.string().required('Subcontract Number is required'),
  pocName: Yup.string().required('POC Name is required'),
  pocEmail: Yup.string().required('POC Email is required'),
  reportingPeriod: Yup.string().required('Reporting Period is required'),
  program: Yup.object().required('Program is required'),
  date: Yup.date().required('Date is required'),
  headcountOnsite: Yup.number().required('Headcount onsite is required'),
  headcountOffsite: Yup.number().required('Headcount offsite is required'),
  manhoursOnsite: Yup.number().required('Man-hours onsite is required'),
  manhoursOffsite: Yup.number().required('Man-hours offsite is required'),
  incidents: Yup.number().required('Number of incidents is required'),
  incidentComment: Yup.string().test(
    'incident-required',
    'Incident comment is required when incidents > 0',
    function (value) {
      const { incidents } = this.parent;
      return Number(incidents) > 0 ? value?.trim() !== '' : true;
    }
  ),
  correctiveActions: Yup.string().test(
    'corrective-required',
    'Corrective actions are required when incidents > 0',
    function (value) {
      const { incidents } = this.parent;
      return Number(incidents) > 0 ? value?.trim() !== '' : true;
    }
  ),
  attachments: Yup.array().of(
    Yup.mixed()
      .test(
        'fileType',
        'Unsupported file format, please select (jpeg, jpg, png, pdf).',
        (file) => {
          return file && SUPPORTED_FORMATS.includes(file.type);
        }
      )
      .test('fileSize', 'File is too large, please select smaller file', (file) => {
        return file && file.size <= 50000000; // Max file size of 50MB
      })
  ),
});
const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

const SHSForm = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission, user } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');

  const [subcontractorOptions, setSubcontractorOptions] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);

  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [tuition, setTuition] = useState(null);
  const [uploadProgress, setUploadProgress] = useState({}); // To track progress for each file
  const [attachments, setAttachments] = useState([]);
  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  const [initialValues, setInitialValues] = useState({
    submitterName: '',
    submitterEmail: '',
    subcontractor: null,
    subcontractNumber: '',
    pocName: '',
    pocEmail: '',
    reportingPeriod: '',
    program:
      profile && profile?.role?.toLowerCase() !== 'admin'
        ? { value: profile.contract, label: profile.contract }
        : null,
    date: new Date(),
    headcountOnsite: '',
    headcountOffsite: '',
    manhoursOnsite: '',
    manhoursOffsite: '',
    incidents: 0,
    incidentComment: '',
    correctiveActions: '',
    attachments: [],
    boxFolderId: '275393000439',
    boxFolderName: 'SHS-Forms',
    timestamp: moment().unix(),
  });

  const [programOptions, setProgramOptions] = useState([]);

  const [subcontractorList, setSubcontractorList] = useState([]);
  // const phoneRegExp = /^\d{3}-\d{3}-\d{4}$/
  const isAdmin = profile?.role?.toLowerCase() === 'admin';
  const isExternalUser = !isAdmin;

  useEffect(() => {
    setFolderAPISuccess(true);
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  useEffect(() => {
    if (profile && profile?.role?.toLowerCase() !== 'admin') {
      setSelectedProgram({ value: profile.contract, label: profile.contract });
    }
  }, [profile]);

  useEffect(() => {
    if (!isAdmin) return;
    getSubcontractorPrograms()
      .then((programs) => {
        const options = (programs || []).map((p) => ({ value: p, label: p }));
        setProgramOptions(options);
      })
      .catch((err) => console.error(err));
  }, [isAdmin]);

  // Fetch subcontractors based on program (admin) or current user (external)
  useEffect(() => {
    if (!isAdmin) {
      getSubcontractorsForMe()
        .then((data) => {
          const options = (data || []).map((s) => ({
            value: s.name,
            label: s.name,
            number: s.number,
            pocName: s.pocname,
            pocEmail: s.pocemail,
          }));
          setSubcontractorOptions(options);

          if (options.length === 1) {
            setInitialValues((prev) => ({
              ...prev,
              subcontractor: options[0],
              subcontractNumber: options[0].number || '',
              pocName: options[0].pocName || '',
              pocEmail: options[0].pocEmail || '',
            }));
          } else {
            setInitialValues((prev) => ({
              ...prev,
              subcontractor: null,
              subcontractNumber: '',
              pocName: '',
              pocEmail: '',
            }));
          }
        })
        .catch((err) => console.error(err));
      return;
    }

    if (selectedProgram) {
      getSubcontractorByProgram(selectedProgram.value)
        .then((data) => {
          const options = data.map((s) => ({
            value: s.name,
            label: s.name,
            number: s.number,
            pocName: s.pocname,
            pocEmail: s.pocemail,
          }));
          setSubcontractorOptions(options);
        })
        .catch((err) => console.error(err));
    } else {
      setSubcontractorOptions([]);
    }
  }, [isAdmin, selectedProgram]);

  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  useEffect(() => {
    if (!profile) return;
    const fullName = [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim();
    const displayName = fullName || profile.email || '';
    setInitialValues((prev) => ({
      ...prev,
      submitterName: displayName,
      submitterEmail: profile.email || '',
      program: isAdmin ? prev.program : { value: profile.contract, label: profile.contract },
    }));
  }, [isAdmin, profile]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const getTuitions = async (email, year, setFieldValue) => {
    await getTuitionsByEmailYear(email, year)
      .then((response) => {
        setTuition(response);
        setFieldValue('tuitionBenefit', response.availableTuitionAmount);
        setFieldValue('tuitionUsed', response.usedTuitionAmount);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Employee Tuition record',
          text: 'Employee tuition record not find for selected year, Please contact your admin',
          width: 400,
          confirmButtonColor: '#3a7afe',
        });
      });
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue, date = moment().toDate()) => {
    setFieldValue(`employeeName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`manager`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    const getManager = await getMTEByEmail(selectedOption.email);
    if (typeof getManager == 'undefined' && profile?.role?.toLowerCase() != 'admin') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Manager is not configured for selected employee, please contact admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`email`, '');
      setFieldValue(`manager`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    setFieldValue(`manager`, getManager.manager || 'Not assigned');
    setFieldValue(`boxFolderId`, '275393000439');
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);
    getTuitions(selectedOption.email, moment(date || moment.toDate()).year(), setFieldValue);
  };

  const handleDatechange = async (date, setFieldValue, email = '') => {
    setFieldValue('date', date);
    if (typeof email != undefined && email != '' && email != null) {
      getTuitions(email, moment(date).year());
    }
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName:
        data.submitterName || (profile ? profile.firstName + ' ' + profile.lastName : ''),
      submitterEmail: data.submitterEmail || profile.email,
      status: 'in progress',
      formType: 'shs-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(async () => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitterName: data.submitterName,
        submitterEmail: data.submitterEmail,
        subcontractor: data.subcontractor.value,
        program: data.program.value,
        attachments: attachments, // Send only the server-side filenames
        boxFolderId: '275393000439',
      };

      handleUploadBatch(payloadForms);
    }
  };

  const handleFileChange = (event, setFieldValue, currentValues, setErrors) => {
    const files = Array.from(event.target.files);
    if (files.length <= 0) {
      setFieldValue('attachments', []);
      setAttachments([]);
    }

    // Validate the files before uploading them
    const validatedFiles = files.filter((file) => {
      const isValidType = SUPPORTED_FORMATS.includes(file.type);
      const isValidSize = file.size <= 50000000; // 50MB file size limit
      return isValidType && isValidSize;
    });

    if (validatedFiles.length === 0) {
      // If no valid files, set Formik error and prevent submission
      setErrors({
        attachments:
          'No valid files selected. Please upload valid files, please select (jpeg, jpg, png, pdf).',
      });
      return;
    }

    // Append new files to the existing array of files
    const updatedFiles = currentValues.attachments
      ? [...currentValues.attachments, ...files]
      : files;

    // Update Formik field value
    setFieldValue('attachments', updatedFiles);
    // Update the selected files state to include the new files
    setAttachments((prev) => [...prev, ...files]);
    // Upload each validated file
    validatedFiles.forEach(uploadFile);
  };

  // Remove a file from the attachments
  const handleRemoveFile = (index, setFieldValue, values, file) => {
    deleteSHSFile(file.name)
      .then(() => {
        setAttachments((prevFiles) => prevFiles.filter((f) => f.name !== file.name));

        const newFiles = values.attachments.filter((_, i) => i !== index);
        setFieldValue('attachments', newFiles);
        // Clear the file input if no files are left
        if (newFiles.length === 0) {
          setFieldValue('attachments', []);
          setAttachments([]); // Clear the field as an empty array
        }

        setUploadProgress((prev) => {
          const newProgress = { ...prev };
          delete newProgress[file.name]; // Remove progress for the deleted file
          return newProgress;
        });
      })
      .catch((error) => {
        console.error('Error deleting file:', error);
      });
  };

  // Upload a single file
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('files', file); // Append the single file to FormData
    // Start upload for this specific file
    await axiosInstance
      .post('file/shs-uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure the content type is set correctly
        },
        onUploadProgress: (progressEvent) => {
          // Safeguard to ensure total is not undefined
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            // Update the progress for this specific file using file.name
            setUploadProgress((prev) => ({
              ...prev,
              [file.name]: percentCompleted,
            }));
          }
        },
        timeout: 600000,
      })
      .then((response) => {
        const fileInfo = {
          name: response.data[0].fileName, // Get the server-generated name
          originalName: file.name, // Keep the original file name
        };
        setAttachments((prevFiles) => [
          ...prevFiles.filter((f) => f.name !== file.name), // Remove old entry if exists
          fileInfo, // Add new uploaded file info
        ]);
        setUploadProgress((prev) => ({
          ...prev,
          [file.name]: 100, // Set 100% progress after successful upload
        }));
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        // Optionally, handle the error state for the specific file
      });
  };

  return (
    <>
      <PageTitle pageTitle="Subcontractor Health and Safety Form" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', paddingBottom: '10px' }}
        >
          <Link className="mb-2 text-primary" target="_blank" to="">
            Instruction to Submit the SHS form
          </Link>
        </div>
        <Card.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, setErrors, errors, touched }) => (
              <FormikForm>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <label>Submitter Name</label>
                    <Field
                      type="text"
                      name="submitterName"
                      className="form-control"
                      placeholder="Submitter Name"
                      readOnly
                    />
                  </Col>
                  <Col>
                    <label>Submitter Email</label>
                    <Field
                      type="text"
                      name="submitterEmail"
                      className="form-control"
                      placeholder="Submitter Email"
                      readOnly
                    />
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    {profile?.role?.toLowerCase() == 'admin' ? (
                      <>
                        <label>Program</label>
                        <Select
                          options={programOptions}
                          value={values.program}
                          onChange={(option) => {
                            setFieldValue('program', option);
                            setSelectedProgram(option);
                            setFieldValue('subcontractor', null);
                            setFieldValue('subcontractNumber', '');
                            setFieldValue('pocName', '');
                            setFieldValue('pocEmail', '');
                          }}
                          placeholder="Select Program"
                        />
                        <ErrorMessage name="program" component="div" className="text-danger" />
                      </>
                    ) : (
                      <>
                        <label>Program</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Program"
                          value={values.program?.label || ''}
                          readOnly
                        />
                        <ErrorMessage name="program" component="div" className="text-danger" />
                      </>
                    )}
                  </Col>
                  <Col>
                    <label>Company Name</label>
                    {isExternalUser && subcontractorOptions.length === 0 ? (
                      <div className="text-danger">
                        No company is assigned to your account. Please contact admin.
                      </div>
                    ) : null}
                    <Select
                      options={subcontractorOptions}
                      value={values.subcontractor}
                      isDisabled={isExternalUser && subcontractorOptions.length === 1}
                      onChange={(option) => {
                        setFieldValue('subcontractor', option);
                        setFieldValue('subcontractNumber', option.number || '');
                        setFieldValue('pocName', option.pocName || '');
                        setFieldValue('pocEmail', option.pocEmail || '');
                      }}
                      placeholder="Select Subcontractor"
                    />

                    {/* <Field
                      as="select"
                      name="subcontractor"
                      className="form-control"
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        setFieldValue('subcontractor', selectedName);

                        const subcontractor = SUBCONTRACTORS.find((s) => s.name === selectedName);
                        if (subcontractor) {
                          setFieldValue('subcontractNumber', subcontractor.number);
                          setFieldValue('pocName', subcontractor.pocName);
                          setFieldValue('pocEmail', subcontractor.pocEmail);
                        }
                      }}
                    >
                      <option value="">Select Subcontractor</option>
                      {SUBCONTRACTORS.map((s, idx) => (
                        <option key={idx} value={s.name}>
                          {s.name}
                        </option>
                      ))}
                    </Field> */}
                    <ErrorMessage name="subcontractor" component="div" className="text-danger" />
                  </Col>
                  <Col>
                    <label>Subcontract Number</label>
                    <Field
                      type="text"
                      name="subcontractNumber"
                      className="form-control"
                      placeholder="subcontract number"
                      readOnly
                    />
                    <ErrorMessage
                      name="subcontractNumber"
                      component="div"
                      className="text-danger"
                    />
                  </Col>
                </Row>

                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <label>POC Name</label>
                    <Field
                      type="text"
                      name="pocName"
                      className="form-control"
                      placeholder="POC Name"
                      readOnly
                    />
                    <ErrorMessage name="pocName" component="div" className="text-danger" />
                  </Col>
                  <Col>
                    <label>POC Email</label>
                    <Field
                      type="text"
                      name="pocEmail"
                      className="form-control"
                      placeholder="POC Email"
                      readOnly
                    />
                    <ErrorMessage name="pocEmail" component="div" className="text-danger" />
                  </Col>
                </Row>

                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <label>Reporting Period</label>
                    <Field as="select" name="reportingPeriod" className="form-control">
                      <option value="">Select Period</option>
                      <option value="Q1">Q1</option>
                      <option value="Q2">Q2</option>
                      <option value="Q3">Q3</option>
                      <option value="Q4">Q4</option>
                    </Field>
                    <ErrorMessage name="reportingPeriod" component="div" className="text-danger" />
                  </Col>

                  <Col>
                    <label>Date</label>
                    <DatePicker
                      selected={values.date}
                      onChange={(date) => setFieldValue('date', date)}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                    />
                    <ErrorMessage name="date" component="div" className="text-danger" />
                  </Col>
                </Row>
                <div className="text-muted small fw-bold mb-2 fst-italic">
                  ** Headcount describes number of people supporting the task, even if only a
                  fraction of FTE **
                </div>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <label>Headcount Onsite</label>
                    <Field
                      type="number"
                      name="headcountOnsite"
                      className="form-control"
                      placeholder="0"
                    />
                    <ErrorMessage name="headcountOnsite" component="div" className="text-danger" />
                  </Col>
                  <Col>
                    <label>Headcount Offsite</label>
                    <Field
                      type="number"
                      name="headcountOffsite"
                      className="form-control"
                      placeholder="0"
                    />
                    <ErrorMessage name="headcountOffsite" component="div" className="text-danger" />
                  </Col>
                </Row>

                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <label>Man-hours Onsite</label>
                    <Field
                      type="number"
                      name="manhoursOnsite"
                      className="form-control"
                      placeholder="0"
                    />
                    <ErrorMessage name="manhoursOnsite" component="div" className="text-danger" />
                  </Col>
                  <Col>
                    <label>Man-hours Offsite</label>
                    <Field
                      type="number"
                      name="manhoursOffsite"
                      className="form-control"
                      placeholder="0"
                    />
                    <ErrorMessage name="manhoursOffsite" component="div" className="text-danger" />
                  </Col>
                </Row>

                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <label>Incidents</label>
                    <Field
                      type="number"
                      name="incidents"
                      className="form-control"
                      placeholder="0"
                    />
                    <ErrorMessage name="incidents" component="div" className="text-danger" />
                  </Col>
                </Row>

                {values.incidents > 0 && (
                  <>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <label>Incident(s) Description</label>
                        <Field
                          as="textarea"
                          name="incidentComment"
                          rows="3"
                          className="form-control"
                          placeholder="Describe incident(s)"
                        />
                        <ErrorMessage
                          name="incidentComment"
                          component="div"
                          className="text-danger"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <label>Corrective Actions</label>
                        <Field
                          as="textarea"
                          name="correctiveActions"
                          rows="3"
                          className="form-control"
                          placeholder="Actions taken"
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row>
                  <Col className="d-flex flex-column justify-content-start" md={6}>
                    <Form.Group>
                      <Form.Label htmlFor="custom-file">
                        Choose File{' '}
                        <span className="text-muted fw-normal">(optional)</span>
                        <strong>
                          &nbsp;&nbsp;&nbsp;&nbsp;(You may attach supporting documentation and images —
                          jpeg, png, or pdf, max 50MB each)
                        </strong>
                      </Form.Label>
                      <Form.Control
                        name={'attachments'}
                        id="custom-file"
                        type="file"
                        multiple
                        onChange={(e) => handleFileChange(e, setFieldValue, values, setErrors)}
                      />
                      {/* Display validation errors from Yup */}
                      {errors.attachments && touched.attachments && (
                        <div className="text-danger">
                          {/* If it's an array, map over the errors */}
                          {Array.isArray(errors.attachments) ? (
                            errors.attachments.map((error, index) => <div key={index}>{error}</div>)
                          ) : (
                            /* If it's a string (e.g., "attachments is required"), display it directly */
                            <div>{errors.attachments}</div>
                          )}
                        </div>
                      )}
                    </Form.Group>

                    {/* Display selected attachments */}
                    {values.attachments.length > 0 && (
                      <div className="mt-2">
                        <strong>Selected Files:</strong>
                        <Col md={8}>
                          <ul>
                            {attachments.map((file, index) => {
                              const progressPercentage =
                                (uploadProgress[file.name]
                                  ? uploadProgress[file.name]
                                  : uploadProgress[file.originalName]) || 0;

                              return (
                                <li
                                  key={file.name}
                                  style={{
                                    marginBottom: '10px',
                                    textAlign: 'left',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <div style={{ flexGrow: 1 }}>
                                      <strong>{file.originalName}</strong> - {progressPercentage}%
                                      <progress
                                        value={progressPercentage}
                                        max="100"
                                        style={{
                                          display: 'block',
                                          width: '100%',
                                          marginTop: '5px',
                                        }} // Added margin for spacing
                                      />
                                    </div>
                                    <Badge
                                      style={{
                                        marginLeft: '20px',
                                        alignSelf: 'flex-start',
                                      }} // Align button properly
                                      variant="danger"
                                      size="sm"
                                      bg="danger"
                                      onClick={() =>
                                        handleRemoveFile(index, setFieldValue, values, file)
                                      }
                                      className="ml-2 mt-4"
                                    >
                                      <i className="fa fa-solid fa-close"></i>
                                    </Badge>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </Col>
                      </div>
                    )}
                  </Col>
                  <Col className="d-flex justify-content-end mt-4" style={{ paddingTop: '7px' }}>
                    <Button variant="primary" style={{ height: 'max-content' }} type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(SHSForm);
